import { render } from "./WebBotTemplateSettings.vue?vue&type=template&id=21b061d6"
import script from "./WebBotTemplateSettings.vue?vue&type=script&lang=js"
export * from "./WebBotTemplateSettings.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__